import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import auth from '@/screens/Auth/store';
import aweber from '@/screens/Aweber/store';
import rdstation from '@/screens/RDStation/store';
import account from '@/screens/Account/store';
import modal from '@/shared/components/modal/store';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.NODE_ENV !== 'staging';

const vuexLocalStorage = new VuexPersist({
  key: 'accountInfo',
  storage: window.localStorage,
  reducer: state => ({
    account: state.account,
  }),
});

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  modules: {
    auth,
    aweber,
    rdstation,
    account,
    modal,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store.js